module.exports = new __parcel__URL__("spin.154f05cf.png").toString();